import React, { useState, useEffect } from "react";
import { Title, Text, Button, Margin, Modal } from "~/components/elements";
import { Link, useLocation } from "react-router-dom";
import { ContentModal } from "./styles";

export default function ModalEmailSignUp({ open, close }) {
  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();

  const handleModal = () => {
    setOpenModal(false);
    close(false);
  };

  useEffect(() => {
    setOpenModal(!!open);
  }, [open]);

  return (
    <Modal class="ModalBatata" open={openModal} closeModal={handleModal}>
      <ContentModal>
        <Margin mb={2}>
          <Title as="2" level="6" className="title">
            Olá!
          </Title>
        </Margin>
        <Margin mb={2}>
          <Text level="3" as="p" primary className="description">
            Verificamos que você já possui cadastro no nosso site!
          </Text>
        </Margin>
        <Margin mb={2}>
          <Text level="3" as="p" primary className="text">
            Entre na sua conta para registrar os produtos e concorra ao prêmios instantâneos.
          </Text>
        </Margin>
        <Margin mb={2}>
          <Link to={`/login${location.search}`}>
            <Button variant="primary">ENTRAR NA CONTA</Button>
          </Link>
        </Margin>
      </ContentModal>
    </Modal>
  );
}
